import { useEffect } from 'react'

import { digObject, toggleArray } from '@domain-group/javascript-utils'

import { UseFormPayload, useSetState } from '@domain-group/react-hooks'

import { CustomFieldModel, CustomFieldOptionValues } from '@domain-group/realhub-backend-api-types'

type ToggleOptionValuesParams = {
  key: string,
  label: string,
  optionValues: CustomFieldOptionValues,
  customFieldOptions: CustomFieldModel['options'],
  setEntityState: UseFormPayload['setEntityState'],
}

const toggleOptionValues = (params: ToggleOptionValuesParams) => {
  const {
    key, label, optionValues, customFieldOptions, setEntityState,
  } = params

  const updatedOptionValues = toggleArray(optionValues, { key, value: label }, { deepCompare: true })

  const updatedOptions = {
    ...customFieldOptions,
    option_values: updatedOptionValues,
  }

  setEntityState({ options: updatedOptions })
}

const defaultState = {
  fieldKey: '',
  fieldLabel: '',
}

type Options = {
  setEntityState?: UseFormPayload['setEntityState'],
}

function useCustomFieldOptionValues(customFieldOptions: CustomFieldModel['options'], options: Options = {}) {
  const [state, setState] = useSetState(defaultState)
  const { fieldKey, fieldLabel } = state

  const { setEntityState } = options

  // @ts-expect-error TS2345
  const optionValues: CustomFieldOptionValues = digObject(customFieldOptions, 'option_values', [])

  useEffect(() => {
    setState({ ...defaultState })
  }, [optionValues.length])

  const optionValueExists = optionValues.some(optionValue => optionValue.key === fieldKey)

  return {
    callbacks: {
      setState,
      toggleOptionValues: (key: string, label: string) => (
        toggleOptionValues({
          // @ts-expect-error TS2322
          key, label, optionValues, customFieldOptions, setEntityState,
        })
      ),
    },
    fieldKey,
    fieldLabel,
    hasOptionValues: !!optionValues.length,
    optionValueExists,
    optionValues,
  }
}

export default useCustomFieldOptionValues
